import { useState } from 'react'
import { Text } from '../../../modules/staking'
import FilterLayout from '../../layouts/FilterLayout'
import { Column, Row } from '../../../styles/TableStyle'
import { FlexCenter } from '../../../styles/CommonStyles'
import { SOCKET_URL } from '../../../core/constants/urls'
import { Market, TextWithMargin } from '../../../styles/OrdersStyle'
import { formatNumber } from '../../../core/utils/common'
import { useTransfers } from '../../../core/hooks/useTransfers'
import { useProfileQuery } from '../../../core/services/react-query/useInternalTransfer'
import MobileModal from '../../modals/MobileModal'
import TransferDetailsModal from './TransferDetailsModal'

const initialModalState = { show: false, data: null }

export const RTransfersHistoryTable = () => {

    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)
    const { data: profile, isLoading: profileLoading } = useProfileQuery()

    const {
        filteredTransfers,
        transfersQueries,
        setTransfersQueries,
        transfersInitialState,
        transfersLoading,
    } = useTransfers()


    return (
        <>
            <FilterLayout
                headers={headers}
                data={filteredTransfers}
                totalPages={filteredTransfers?.meta.total}
                hasCoinOption={true}
                isCurrency={true}
                noDataTop={'200px'}
                state={{
                    filterQueries: transfersQueries,
                    setFilterQueries: setTransfersQueries,
                    initialState: transfersInitialState,
                }}
                loading={profileLoading || transfersLoading}
            >
                {filteredTransfers?.data?.map((item) => {
                    const isToman = item.currency === 'irt'
                    const isReceiver = profile?._id === item?.toId

                    return (
                        <Row
                            onClick={() => { setModal({ data: item, show: true }) }}
                            key={item._id}
                        >
                            {/* Coin */}
                            <Column className='w-[33.333%]'>
                                <FlexCenter>
                                    <img
                                        src={
                                            isToman
                                                ? require('../../../assets/images/tooman.png')
                                                : SOCKET_URL + `assets/icon/${item.currency}.png`
                                        }
                                        alt={item.currency}
                                        className='w-6 h-6'
                                    />
                                    <Market>{item.currency.toUpperCase()}</Market>
                                </FlexCenter>
                            </Column>

                            {/* Type */}
                            <Column className='w-[33.333%]'>
                                <FlexCenter>
                                    <TextWithMargin type={isReceiver ? 'receive' : 'send'}>
                                        {isReceiver ? <Text tid='receive' /> : <Text tid='send' />}
                                    </TextWithMargin>
                                </FlexCenter>
                            </Column>

                            {/* Amount */}
                            <Column number className='w-[33.333%]'>
                                {item.amount ? formatNumber(item.amount) : '--'}
                            </Column>

                        </Row>
                    )
                })}
            </FilterLayout>
            {!profileLoading &&
                <MobileModal isOpen={modal.show} onClose={onCloseModal}>
                    <TransferDetailsModal data={modal.data} profileId={profile._id} onClose={onCloseModal} />
                </MobileModal>
            }
        </>
    )
}

const headers = [
    { title: 'coin', width: 'w-[33.333%]' },
    { title: 'transfer-type', width: 'w-[33.333%]' },
    { title: 'amount', width: 'w-[33.333%]' },
]